import { createI18n } from 'vue-i18n';
import messages from '@intlify/unplugin-vue-i18n/messages';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function createAgonI18n(locale: string) {
  return createI18n({
    legacy: true,
    locale: locale || 'en',
    fallbackLocale: 'en',
    messages: messages,
  });
}
